import React from 'react';
import Button from '../../components/button/button.jsx';
import './articleindex.scss'

const ArticleTeaser = ({img, title, tag, url}) => {
	return <article className="component article --teaser" onClick={()=>{console.log(url)}}>
				<img src={ img } alt={ title }/>
				<span className="tag">{ tag }</span>
				<h1>{ title }</h1>
				<Button icon={'plus'} iconinline={true} text={'Read more'} clickEvent={'Component.ArticleTeaser.Open'} fields={{url : url}}/>
			</article>
}


const ArticleIndex = ({data}) => {

	window.addEventListener('Component.ArticleTeaser.Open', (e) => window.open(e.detail.url), false);

	return 	<section className="component articleindex">
				<div className="inner">
					{data.map((item, i) => {
						return <ArticleTeaser key={i} {...item}/>
					})}
				</div>
			</section>
}

export default ArticleIndex;


// WEBPACK FOOTER //
// ./src/blocks/articleindex/articleindex.jsx